import axios from 'axios'
import qs from 'qs'
import {redirectToError} from '@/public/redirectTo'
import * as util from '@/public/util'

let baseURL = 'https://ms.jr.jd.com/gw/generic/jrm/h5/'
if (util.isCeshi) {
  baseURL = 'http://msinner.jr.jd.com/gw/generic/jrm/h5/'
}
const instance = axios.create({
  baseURL
})

// 让ajax请求头携带cookie
instance.defaults.withCredentials = true;
instance.defaults.crossDomain = true;
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

instance.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  } else {
    config.params = config.params || {}
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

instance.interceptors.response.use(function (res) {
  let {resultCode,resultMsg,resultData} = res.data || {}

  //未登录, 跳登录
  if(resultCode == 3  &&  $.device.weixin ){
    let enLink = encodeURIComponent(encodeURIComponent(location.href));
    let userUrl = `https://passport.m.jd.com/user/login.action?returnurl=http%3a%2f%2fjrappgw.jd.com%2fwxjdissue%2fjdissueWX%2fdispatch%3furl%3d${enLink}`;

    window.location.href = userUrl;
    return
  }

  // 屏蔽网关报错信息
  if(Number(resultCode) !== 0){
    redirectToError()
  }

  // 屏蔽风控用户
  if(resultData && resultData.code === '10004zt'){
    redirectToError('', resultData.code)
  }

  return resultData;
}, function (error) {
  return Promise.reject(error)
})


export default instance



// WEBPACK FOOTER //
// ./src/api/axios.conf.js